import { TFunction } from "next-i18next";
import { UTSLocale } from "@smile2impress/attraction-constants";

import defaultContent from "./default-content";

export default (t: TFunction, locale: UTSLocale) => defaultContent(t, locale);
